import { Component, OnInit, EventEmitter } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { PonchoUIModule } from '@poncho/ui';

@Component({
    selector: 'app-cancel-order-confirmation',
    templateUrl: './cancel-order-confirmation.component.html',
    styleUrls: ['./cancel-order-confirmation.component.scss'],
    standalone: true,
    imports: [MatDialogModule, PonchoUIModule]
})
export class CancelOrderConfirmationComponent implements OnInit {

    confirmed = new EventEmitter();

    constructor(
        private dialogRef: MatDialogRef<CancelOrderConfirmationComponent>
    ) {}

    ngOnInit() {}

    close() {
        this.dialogRef.close();
    }

    confirm() {
        this.confirmed.emit();
        this.close();
    }
}
